import React, { useState, useEffect } from "react";
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
} from "@progress/kendo-react-charts";
import "hammerjs";

// Add prop setSeverityFilter to filter grid from chart
const RealTimeAlertChart = ({ alerts, setSeverityFilter }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const updateChartData = () => {
      const severityCounts = {
        High: alerts.filter((a) => a.severity === "High").length,
        Medium: alerts.filter((a) => a.severity === "Medium").length,
        Low: alerts.filter((a) => a.severity === "Low").length,
      };

      const newData = [
        { category: "High", value: severityCounts.High, color: "#dc3545" },
        { category: "Medium", value: severityCounts.Medium, color: "#ffc107" },
        { category: "Low", value: severityCounts.Low, color: "#28a745" },
      ];

      setChartData(newData);
    };

    updateChartData();
    const interval = setInterval(updateChartData, 3000);

    return () => clearInterval(interval);
  }, [alerts]);

  // Handler for click/tap on a bar in the chart
  const handleSeriesClick = (e) => {
    if (!setSeverityFilter) return;
    // Use e.dataItem.category first, then e.category
    const cat = e?.dataItem?.category || e?.category;
    if (!cat) return;
    setSeverityFilter((prev) => (prev === cat ? null : cat));
  };

  return (
    <div
      style={{
        margin: "20px 0",
        padding: "20px",
        background: "white",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <Chart
        style={{ height: "100%", minHeight: "150px" }}
        onSeriesClick={handleSeriesClick}
      >
        <ChartSeries>
          <ChartSeriesItem
            type="column"
            data={chartData}
            field="value"
            categoryField="category"
            color={(dataItem) => {
              // Set color based on category
              switch (dataItem.category) {
                case "High":
                  return "#dc3545";
                case "Medium":
                  return "#ffc107";
                case "Low":
                  return "#28a745";
                default:
                  return "#6c757d";
              }
            }}
          />
        </ChartSeries>
      </Chart>
    </div>
  );
};

export default RealTimeAlertChart;
